<template>
  <MilestoneDetails
    :milestone="getNewMilestone(project_id)"
    >
    <template #header="{milestone}">
      <MileStone
        class="ml-4 mt-7"
        :large="true"
        type="train"
        >
        <StandardDataField
          :value="milestone.milestone.token"
          width="100%"
          flat="true"
          text_center="true"
          :maxlength="2"
          :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
          @changeValue="updateNewMilestone({
            prop: 'token',
            value: $event.substring(0, 2).toUpperCase()
            })"
          />
      </MileStone>
      <StandardDataField
        class="ml-10"
        :value="milestone.milestone.name"
        :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
        width="80%"
        @changeValue="updateNewMilestone({
          prop: 'name',
          value: $event
        }),
        milestone.milestone.token === ''?
        updateNewMilestone({
          prop: 'token',
          value: $event.substring(0, 2).toUpperCase()
        }):''"
        />
    </template>
    <template #body="{milestone}">
      <v-divider class="mb-1"/>
      <StandardFlexBox>
        <v-spacer/>
        <StandardDataField
          :value="milestone.milestone.offset"
          :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
          width="15%"
          type="number"
          text_align="right"
          @changeValue="updateNewMilestone({
            prop: 'offset',
            value: parseInt($event)
            })"
          />
        <div class="ml-2">TT</div>
        <v-spacer/>
        <StandardDropdown
          class="ma-0"
          :value="milestone.milestone.chronology"
          :options="[{name: 'before'}, {name: 'after'}]"
          color="color-3"
          @changeValue="updateNewMilestone({
            prop: 'chronology',
            value: $event.name,
            })"
        />
      </StandardFlexBox>
      <v-divider class="mt-1 mb-1"/>
      <v-tabs
        fixed-tabs
        background-color="color-3"
        height="36px"
        :value="['selection', 'type'].indexOf(milestone.milestone.linkType)"
        @change="updateNewMilestone({
          prop: 'linkType',
          value: ['selection', 'type'][$event],
          })"
        >
        <v-tab>{{$t('Project.Milestones.Train.Selection')}}</v-tab>
        <v-tab>{{$t('Project.Milestones.Train.Type')}}</v-tab>
      </v-tabs>
      <template v-if="milestone.milestone.linkType !== 'type'">
      <div class="mt-1" style="font-size: 12px">
        {{milestone.milestone.trains.length}} {{$t('Project.Milestones.Train.TrainS[0]')}}{{milestone.milestone.trains.length === 1?'': $t('Project.Milestones.Train.TrainS[1]')}},
        {{milestone.milestone.taktareas.length}} {{$t('Project.Milestones.Train.TaktareaS[0]')}}{{milestone.milestone.taktareas.length === 1?'': $t('Project.Milestones.Train.TaktareaS[1]')}},
        {{milestone.milestone.tworkpackages.length}} {{$t('Project.Milestones.Train.WorkpackageS[0]')}}{{milestone.milestone.tworkpackages.length === 1?'': $t('Project.Milestones.Train.TrainS[1]')}}
      </div>
      <div class="mb-2" style="font-size: 12px">
        {{$t('Project.Milestones.Train.CalculatedDate')}}: {{milestone.calculated_date?milestone.calculated_date.toISOString().substring(0,10):''}}
      </div>
      <StandardFlexBox
        direction="column"
        height="84%"
        :no_wrap="true"
        gap="12px"
        >
      <div
        v-for="train in milestone.selection"
        :key="train.id"
        :style="train.selected?'color: white':'color: #757575'"
        >
        <v-divider/>
        <StandardFlexBox class="mt-1" height="30px">
          <v-icon v-if="train.selected" size="16">check_circle</v-icon>
          <div
            class="ml-1 cursor-pointer"
            @click="editNewMilestoneSelection({
              project_id: project_id,
              prop: 'trains',
              value: train,
            });"
            >
            {{getTrain(train.id).name}}
            <div v-if="milestone.decisive_entity.type == 'train' && milestone.decisive_entity.id == train.id" class="milestone-icon"/>
          </div>
        </StandardFlexBox>
        <div
          class="ml-3"
          v-for="taktarea in train.taktareas"
          :key="taktarea.id"
          :style="taktarea.selected?'color: white':'color: #757575'"
          >
          <StandardFlexBox class="mt-1" height="30px">
            <v-icon v-if="taktarea.selected" size="16">check_circle</v-icon>
            <div
              class="ml-1 cursor-pointer"
              @click="editNewMilestoneSelection({
                project_id: project_id,
                prop: 'taktareas',
                value: taktarea,
              });"
              >
              {{getTaktarea(taktarea.id).name}}
              <div v-if="milestone.decisive_entity.type == 'taktarea' && milestone.decisive_entity.id == taktarea.id" class="milestone-icon"/>
            </div>
          </StandardFlexBox>
          <StandardFlexBox
          class="ml-3"
          >
            <WorkPackage
              v-for="work_package in taktarea.work_packages"
              :key="work_package.id"
              class="ml-1 mb-1 cursor-pointer"
              :style="(milestone.decisive_entity.type == 'work_package' && milestone.decisive_entity.id == work_package.id)?'border-style: solid; border-width: 1px !important; border-color: white !important; border-radius: 5px;':''"
              :workpackage="getTWorkPackage(work_package.id)"
              :zoom="0.75"
              @click.native="editNewMilestoneSelection({
                project_id: project_id,
                prop: 'work_packages',
                value: work_package,
                train: train,
              });"
            />
          </StandardFlexBox>
        </div>
      </div>
      </StandardFlexBox>
    </template>
    <template v-else>
      <div class="mb-2 mt-1" style="font-size: 12px">
        {{$t('Project.Milestones.Train.CalculatedDate')}}: {{milestone.calculated_date?milestone.calculated_date.toISOString().substring(0,10):''}}
      </div>
        <StandardFlexBox class="mt-3 ml-1" height="35px">
          <v-icon
            size="24"
            :color="milestone.milestone.wp_color_active?'':'grey darken-1'"
            @click="updateNewMilestone({
              prop: 'wp_color_active',
              value: milestone.milestone.wp_color_active?false:true,
              })"
            >
            {{milestone.milestone.wp_color_active?'check_box':'check_box_outline_blank'}}
          </v-icon>
          <div
            class="ml-1"
            :style="milestone.milestone.wp_color_active?'':'color: #757575'"
            >
            {{$t('Project.Milestones.Train.Color')}}:
          </div>
          <StandardDropdown
            class="ma-0"
            :value="milestone.milestone.wp_color"
            :color="milestone.milestone.wp_color_active?'white':'color-3'"
            :textcolor="milestone.milestone.wp_color_active?'black':''"
            option_color="true"
            :options="getTWorkpackageColors"
            width="100px"
            @changeValue="updateNewMilestone({
              prop: 'wp_color',
              value: $event.value,
              }),
              updateNewMilestone({
                prop: 'wp_color_active',
                value: true,
                })"
            />
        </StandardFlexBox>
        <StandardFlexBox class="ml-1" height="35px">
          <v-icon
            size="24"
            :color="milestone.milestone.wp_token_active?'':'grey darken-1'"
            @click="updateNewMilestone({
              prop: 'wp_token_active',
              value: milestone.milestone.wp_token_active?false:true,
              })"
            >
            {{milestone.milestone.wp_token_active?'check_box':'check_box_outline_blank'}}
          </v-icon>
          <div
            class="ml-1"
            :style="milestone.milestone.wp_token_active?'':'color: #757575'"
            >
            {{$t('Project.Milestones.Train.Token')}}:
          </div>
          <StandardDropdown
            class="ma-0"
            :value="milestone.milestone.wp_token"
            :color="milestone.milestone.wp_token_active?'white':'color-3'"
            :textcolor="milestone.milestone.wp_token_active?'black':''"
            :options="getTWorkpackageTokens"
            width="100px"
            @changeValue="updateNewMilestone({
              prop: 'wp_token',
              value: $event.name,
              }),
              updateNewMilestone({
                prop: 'wp_token_active',
                value: true,
                })
              "
            />
        </StandardFlexBox>
        <StandardFlexBox class="ml-1" height="35px">
          <v-icon
            size="24"
            :color="milestone.milestone.wp_icon_active?'':'grey darken-1'"
            @click="updateNewMilestone({
              prop: 'wp_icon_active',
              value: milestone.milestone.wp_icon_active?false:true,
              })"
            >
            {{milestone.milestone.wp_icon_active?'check_box':'check_box_outline_blank'}}
          </v-icon>
          <div
            class="ml-1"
            :style="milestone.milestone.wp_icon_active?'':'color: #757575'"
            >
            {{$t('Project.Milestones.Train.Icon')}}:
          </div>
          <StandardDropdown
            class="ma-0"
            :value="milestone.milestone.wp_icon"
            :color="milestone.milestone.wp_icon_active?'white':'color-3'"
            :textcolor="milestone.milestone.wp_icon_active?'black':'white'"
            option_icon="true"
            :options="getTWorkpackageIcons"
            width="100px"
            @changeValue="updateNewMilestone({
              prop: 'wp_icon',
              value: $event.value,
              }),
              updateNewMilestone({
                prop: 'wp_icon_active',
                value: true,
                })
              "
            />
        </StandardFlexBox>
        <StandardFlexBox class="ml-1" height="60px">
          <v-icon
            size="24"
            :color="milestone.milestone.wp_name_active?'':'grey darken-1'"
            @click="updateNewMilestone({
              prop: 'wp_name_active',
              value: milestone.milestone.wp_name_active?false:true,
              })"
            >
            {{milestone.milestone.wp_name_active?'check_box':'check_box_outline_blank'}}
          </v-icon>
          <div
            class="ml-1"
            :style="milestone.milestone.wp_name_active?'':'color: #757575'"
            >
            {{$t('Project.Milestones.Train.Name')}}:
          </div>
          <StandardDropdown
            class="ma-0"
            :value="milestone.milestone.wp_name"
            :color="milestone.milestone.wp_name_active?'white':'color-3'"
            :textcolor="milestone.milestone.wp_name_active?'black':''"
            :options="getTWorkpackageNames"
            width="100px"
            @changeValue="updateNewMilestone({
              prop: 'wp_name',
              value: $event.name,
              }),
              updateNewMilestone({
                prop: 'wp_name_active',
                value: true,
                })
              "
            />
        </StandardFlexBox>
    </template>
    </template>
    <template #button>
      <v-btn
        width="100%"
        @click="createUObject({
            url: [
              {projects: project_id},
              {milestones: ''},
              {'showWithEntitiesNormalized': ''}
            ],
            u_object: getNewMilestoneForPayload(project_id)
          }).then((milestone_id) => {
            createMilestone({
            project_id: project_id,
            milestone_id: milestone_id,
            milestone_type: 'milestones',
            })
          })"
        >
        <v-icon>add</v-icon>
        {{$t('Project.Milestones.AddMilestone')}}
      </v-btn>
    </template>
  </MilestoneDetails>
</template>
<script>
  import { MilestonesMixin } from '@/mixins/Milestones.mixin.js'
  export default {
    props: ['project_id', 'milestone_id'],
    components:{
    },
    mixins: [
      MilestonesMixin
    ],
    methods: {

    },
    beforeRouteLeave(to, from, next) {
      this.resetNewMilestone();
      next();
    }
  }
</script>
<style scoped>
  .milestone-icon {
    margin-top: 3px;
    margin-left: 5px;
    width: 12px;
    height: 12px;
    border-radius: 2px;
    transform: rotate(45deg);
    cursor: pointer;
    background-color: white;
    background-color: var(--v-primary-base);
    display: inline-block;
  }
</style>
